import React from 'react';

import classNames from 'classnames';

// Shared empty state: a muted icon medallion, a heading naming what is missing, one line of
// body copy saying what the thing is for, and an optional action.
//
// role="status" so a screen reader is told the list came back empty. Without it the only
// signal is a silent swap of the rows for this block, which announces nothing.
export default function EmptyState({ icon: Icon, heading, body, action, className }) {
    return (
        <div role="status" className={classNames('tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-px-6', className)}>
            {Icon && (
                <div className="tw-flex tw-items-center tw-justify-center tw-h-14 tw-w-14 tw-rounded-full tw-bg-background tw-mb-4">
                    <Icon className="tw-h-6 tw-w-6 tw-text-charcoal-50" aria-hidden="true" />
                </div>
            )}
            <h4 className="tw-text-base tw-font-semibold tw-text-charcoal tw-mb-1">{heading}</h4>
            {body && <p className="tw-text-sm tw-text-charcoal-75 tw-max-w-sm">{body}</p>}
            {action && <div className="tw-mt-4">{action}</div>}
        </div>
    );
}
